export default {

  methods: {

    pastelColors () {
      var r = (Math.round(Math.random() * 127) + 127).toString(16)
      var g = (Math.round(Math.random() * 127) + 127).toString(16)
      var b = (Math.round(Math.random() * 127) + 127).toString(16)
      return '#' + r + g + b
    }

  }

}
